import React, { forwardRef, useEffect, useRef,useImperativeHandle } from "react";
import useEditorStore from "@/store/useEditorStore";



const LassoLayer = forwardRef(({width, size},ref) => {
    const opMode = useEditorStore.use.op_mode();
    const lassoStart = useEditorStore.use.lassoStart();
    const lassoEnd = useEditorStore.use.lassoEnd();
    return (<g ref={ref}>
      {opMode == 3 && lassoStart && lassoEnd ? (
            <rect
                x={Math.min(lassoStart.x, lassoEnd.x)}
                y={Math.min(lassoStart.y, lassoEnd.y)}
                width={Math.abs(lassoEnd.x - lassoStart.x)}
                height={Math.abs(lassoEnd.y - lassoStart.y)}
                fill="rgba(20,125,255,0.1)"
                stroke="#ff7f0e"
                strokeDasharray="10 5"
            />
        ):null}
    </g>);
});

export default LassoLayer;
